import { render, staticRenderFns } from "./payments-list-page.vue?vue&type=template&id=5c9e52b3&"
import script from "./payments-list-page.vue?vue&type=script&lang=js&"
export * from "./payments-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports